// src/api/user/account.api.js
import api from '../client';

/**
 * GET /user/my
 * 현재 로그인한 사용자의 기본 계정 정보(email, default_role 등)를 가져온다.
 */
export const getMyAccount = () =>
  api.get('/user/my').then((r) => r.data);

/**
 * GET /user/my/profile
 * 현재 로그인한 사용자의 프로필(full_name, avatar_url 등)을 가져온다.
 */
export const getMyProfile = () =>
  api.get('/user/my/profile').then((r) => r.data);

/**
 * PATCH /user/my/profile
 * 프로필 부분 수정. payload는 UserProfileUpdate 스키마와 동일.
 * 가능한 키: full_name, job_title, department, phone_number, location, bio,
 *           user_field, user_field_etc, organization, ai_experience, purpose, purpose_etc
 */
export const updateMyProfile = (payload) =>
  api.patch('/user/my/profile', payload).then((r) => r.data);

/**
 * POST /user/class/invites/redeem
 * 클래스 초대코드 등록.
 * @param {string} code  - 6자리 초대코드
 */
export const redeemClassInvite = (code) =>
  api.post('/user/class/invites/redeem', { code }).then((r) => r.data);

/**
 * GET /user/my/privacy
 * 프라이버시/수신동의 설정을 가져온다.
 * 응답 예: { marketing_privacy_agreed, marketing_privacy_agreed_at,
 *          marketing_email_agreed, marketing_email_agreed_at,
 *          terms_agreed_at, terms_version, ... }
 */
export const getMyPrivacy = () =>
  api.get('/user/my/privacy').then((r) => r.data);

/**
 * PATCH /user/my/privacy
 * 선택 수신동의 토글 부분 수정. 두 항목은 독립 — 변경한 것만 보낸다.
 * 동의/철회 시각(*_agreed_at)은 서버가 자동 스탬프하므로 boolean만 전송.
 * @param {{ marketing_privacy_agreed?: boolean, marketing_email_agreed?: boolean }} payload
 */
export const updateMyPrivacy = (payload) =>
  api.patch('/user/my/privacy', payload).then((r) => r.data);
